<template>
<!--Product Area Start-->
<section class="product-area mt-text-2">
    <div class="container custom-area-2 overflow-hidden">
        <div class="row">
            <!--Section Title Start-->
            <div class="col-12 col-custom">
                <div class="section-title text-center mb-30">
                    <span class="section-title-1">{{ $trans('nya::product.wonderful_gift') }}</span>
                    <h3 class="section-title-3">{{ $trans('nya::product.featured_products') }}</h3>
                </div>
            </div>
            <!--Section Title End-->
        </div>
        <div class="row product-row">
            <div class="col-12 col-custom">
                <div class="product-slider swiper-container anime-element-multi">
                    <div class="swiper-wrapper">
                        <div class="single-item swiper-slide pt-3">
                            <!--Single Product Start-->
                            <div class="single-product position-relative mb-30">
                                <ProductCard v-for="product in features" :key="product.id" :product="product"/>
                            </div>
                            <!--Single Product End-->
                        </div>
                    </div>
                    <!-- Slider pagination -->
                    <div class="swiper-pagination default-pagination"></div>
                </div>
            </div>
        </div>
    </div>
</section>

</template>

<script>
    import ProductCardMixin from '../../mixins/ProductCardMixin';
    import ProductCard from './../ProductCard';

    export default {
        mixins: [
            ProductCardMixin,
        ],
         components: { ProductCard },

        props: ['features'],
    };
</script>
